export default __webpack_public_path__ + "static/media/blood.a9c73b06.svg";